// extracted by mini-css-extract-plugin
module.exports = {"root":"EllipsisTextWithTooltip_root__2844d"};